import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Loading } from '@defa/defa-component-library';
import { Login } from '@screens/login/login';
import { SupportLogin } from '@screens/login/support-login';
import { PrivateRoute } from '@utils/private-route';
import { Root } from './app.styles';
import { CreateAccount } from '@screens/create-account';
import { updateLocale } from '@i18n';
import { AcceptInvitation } from '@screens/accept-invitation';
import { Welcome } from '@screens/welcome';
import { ResetPassword } from '@screens/reset-password';
import { ResetPasswordNewPassword } from '@screens/reset-password/reset-password-new-password';
import { AnonymousInviteFacility } from '@screens/anonymous-invite-facility';
import { AnonymousInviteHome } from '@screens/anonymous-invite-home';
import { RfidInvite } from '@screens/rfid-invite';
import { apolloClient } from './apollo-client';
import { ApolloProvider } from '@apollo/client';
import { AppProviders } from '@providers/app-providers';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './query-client';
import './admin-prime-client';
import './rfid-invite-client';
import './subscription-service-client';
import './kaiser-client';

const Portal = React.lazy(() => import('@screens/portal'));

updateLocale(navigator.language);

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const App: React.FunctionComponent = () => (
    <ApolloProvider client={apolloClient}>
        <QueryClientProvider client={queryClient}>
            <Root>
                <AppProviders>
                    <SentryRoutes>
                        <Route path="/sl" element={<SupportLogin />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/login/:msg" element={<Login />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/passwordreset.html" element={<ResetPasswordNewPassword />} />
                        <Route path="/create-account" element={<CreateAccount />} />
                        <Route path="/accept-invitation" element={<AcceptInvitation />} />
                        <Route path="/anonymous-facility" element={<AnonymousInviteFacility />} />
                        <Route path="/anonymous-home" element={<AnonymousInviteHome />} />
                        <Route path="/rfid-invite" element={<RfidInvite />} />
                        <Route path="/welcome" element={<Welcome />} />
                        <Route
                            path="/*"
                            element={
                                <PrivateRoute>
                                    <Suspense fallback={<Loading />}>
                                        <Portal />
                                    </Suspense>
                                </PrivateRoute>
                            }
                        />
                    </SentryRoutes>
                </AppProviders>
            </Root>
        </QueryClientProvider>
    </ApolloProvider>
);
